import { FC } from 'react'
import { HeaderBar, IconButton, makeStyles, useMediaQuery } from '@perk-ui/core'
import { Menu } from 'react-feather'
import { useLocation } from 'react-router-dom'

import config from '../config/environments/development'
import { useAuth } from '../features/auth/AuthContext'
import AppLink from './AppLink'
import KnowledgeBaseButton from './KnowledgeBaseButton'
import ProfileDropdown from './ProfileDropdown'
import SitesDropdown from './SitesDropdown'
import { useSitesContext } from './SitesProvider'

export interface AppHeaderProps {
  onMenuClick?: () => void
}

const useStyles = makeStyles((theme) => ({
  gap: {
    paddingRight: theme.spacing(3),
  },
  header: {
    zIndex: 1201,
  },
}))

export const pathsWithoutHeader = [
  '/login',
  '/create-account',
  '/register-provider',
  '/login-new',
  '/forgot-password',
  '/password-reset',
  '/activate-account',
  '/resend-activation-link',
  '/onboarding',
  '/sign-contract',
  '/payment',
  '/provider',
  '/patient-self-onboard',
]

const AppHeader: FC<AppHeaderProps> = ({ onMenuClick }) => {
  const classes = useStyles()
  const isMobile = useMediaQuery('(max-width: 899.95px)')
  const { isAuthenticated } = useAuth()
  const { pathname } = useLocation()
  const { currentSite } = useSitesContext()
  const isCurrentLocation = (path: string) => pathname.startsWith(path)
  const showHeader = !pathsWithoutHeader.some(isCurrentLocation)

  return showHeader && isAuthenticated && currentSite ? (
    <HeaderBar
      className={classes.header}
      left={
        <AppLink
          to={
            isAuthenticated
              ? config.authenticatedRootUrl
              : config.unAuthenticatedRootUrl
          }
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/DataBiologics_Logo.png`}
            height="30"
            style={{ display: 'block' }}
          />
        </AppLink>
      }
      right={
        isAuthenticated && (
          <>
            {!isMobile && <KnowledgeBaseButton />}
            {!isMobile && <SitesDropdown />}
            {!isMobile && (
              <>
                <div className={classes.gap} />
                <ProfileDropdown />
              </>
            )}
            {isMobile && (
              <IconButton onClick={onMenuClick} sx={{ ml: 1 }}>
                <Menu size={20} />
              </IconButton>
            )}
          </>
        )
      }
      position="fixed"
    />
  ) : null
}

export default AppHeader
